var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalendar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.6,
  d: "M13.334 2.5v3.333M6.667 2.5v3.333M3.334 9.167h13.333M3.334 5.833a1.667 1.667 0 0 1 1.667-1.666h10a1.667 1.667 0 0 1 1.666 1.666v10a1.667 1.667 0 0 1-1.666 1.667H5a1.667 1.667 0 0 1-1.667-1.667z"
})));
export default SvgCalendar;